import BaseApi from '../BaseApi';

interface ProductTransaction {
  GetProductTransaction: (type: number, state: number, timeStart: any, timeEnd: any) => Promise<any>;
  GetMixed: (type: number, state: number, timeStart: any, timeEnd: any, sender: any, recevier: any) => Promise<any>;
  GetOwn: (type: number, state: number, timeStart: any, timeEnd: any) => Promise<any>;
  BulkAssign: (dataBody: any) => Promise<any>;
  ConfirmAssign: (dataBody: any) => Promise<any>;
  Exchange: (dataBody: any) => Promise<any>;
  Return: (dataBody: any) => Promise<any>;
  Undo: (dataBody: any) => Promise<any>;
  ConfirmExchange: (dataBody: any) => Promise<any>;
  ConfirmReturn: (dataBody: any) => Promise<any>;
  UpdateProductTransaction: (dataBody: any) => Promise<any>;
  ConfirmProductTransaction: (dataBody: any) => Promise<any>;
  ConfirmUndo: (dataBody: any) => Promise<any>;
  GetDetailById: (id: any) => Promise<any>;
  Cancel: (id: any) => Promise<any>;
  GetTypeAndState: () => Promise<any>;
  GetStateTech: () => Promise<any>;
  GetUsedProduct: (dataBody: any) => Promise<any>;
  GetUsedProductV2: (dataBody: any) => Promise<any>;

  // Technician
  GetByUserName: (state: number, userName: any) => Promise<any>;
  GetOwnerTech: (state: number, timeStart?: any, timeEnd?: any) => Promise<any>;
  GetTech: (state: number, timeStart: any, timeEnd: any) => Promise<any>;
  GetTechMixed: (state: number, owner: any, timeStart?: any, timeEnd?: any) => Promise<any>;
  CreateTechnicianProduct: (dataBody: any) => Promise<any>;
  DeleteTechnicianProduct: (dataBody: any) => Promise<any>;
}

const ProductTransactionApi: ProductTransaction = {
  GetProductTransaction: (type: number, state: number, timeStart: any, timeEnd: any) => {
    return BaseApi.GET(`api/ProductTransaction/Get?Type=${type}&State=${state}&From=${timeStart}&To=${timeEnd}`);
  },
  GetMixed: (type: number, state: number, timeStart: any, timeEnd: any, sender: any, recevier: any) => {
    return BaseApi.GET(
      `api/ProductTransaction/GetMixed?Type=${type}&State=${state}&From=${timeStart}&To=${timeEnd}&Sender=${sender}&Receiver=${recevier}`
    );
  },
  BulkAssign: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/BulkAssign', dataBody);
  },
  UpdateProductTransaction: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/Update', dataBody);
  },
  ConfirmProductTransaction: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/ConfirmUpdate', dataBody);
  },
  ConfirmUndo: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/ConfirmUndo', dataBody);
  },
  ConfirmAssign: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/ConfirmAssign', dataBody);
  },
  GetOwn: (type: number, state: number, timeStart: any, timeEnd: any) => {
    return BaseApi.GET(`api/ProductTransaction/GetOwn?Type=${type}&State=${state}&From=${timeStart}&To=${timeEnd}`);
  },
  GetDetailById: (id: number) => {
    return BaseApi.GET(`api/ProductTransaction/GetDetailById?id=${id}`);
  },
  Cancel: (id: number) => {
    return BaseApi.DELETE(`api/ProductTransaction/Cancel?id=${id}`);
  },
  GetTypeAndState: () => {
    return BaseApi.GET('api/ProductTransaction/GetTypeAndState');
  },
  Exchange: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/Exchange', dataBody);
  },
  Return: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/Return', dataBody);
  },
  Undo: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/Undo', dataBody);
  },
  ConfirmExchange: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/ConfirmExchange', dataBody);
  },
  ConfirmReturn: (dataBody: any) => {
    return BaseApi.POST('api/ProductTransaction/ConfirmReturn', dataBody);
  },

  // Technician

  GetUsedProduct: (dataBody: any) => {
    return BaseApi.POST('api/TechnicianProduct/GetUsedProduct', dataBody);
  },
  GetUsedProductV2: (dataBody: any) => {
    return BaseApi.POST('api/TechnicianProduct/GetUsedProductV2', dataBody);
  },
  GetByUserName: (state: number, userName: any) => {
    return BaseApi.GET(`api/TechnicianProduct/GetByUserName?state=${state}&userName=${userName}`);
  },
  GetOwnerTech: (state: number, timeStart?: any, timeEnd?: any) => {
    // &From=${timeStart}&To=${timeEnd}
    return BaseApi.GET(`api/TechnicianProduct/GetOwn?State=${state}`);
  },
  GetTech: (state: number, timeStart: any, timeEnd: any) => {
    return BaseApi.GET(`api/TechnicianProduct/Get?State=${state}&From=${timeStart}&To=${timeEnd}`);
  },
  GetTechMixed: (state: number, owner: any, timeStart?: any, timeEnd?: any) => {
    // &From=${timeStart}&To=${timeEnd}
    return BaseApi.GET(`api/TechnicianProduct/GetMixed?State=${state}&Owner=${owner}`);
  },
  GetStateTech: () => {
    return BaseApi.GET('api/TechnicianProduct/GetState');
  },
  CreateTechnicianProduct: (dataBody: any) => {
    return BaseApi.POST('api/TechnicianProduct/Create', dataBody);
  },
  DeleteTechnicianProduct: (dataBody: any) => {
    return BaseApi.DELETE('api/TechnicianProduct/Delete?', null, dataBody);
  }
};

export default ProductTransactionApi;
